import { useState } from 'react';
import { t } from 'i18next';
import DataGridWrapper from '@/core/wrappers/data-grid-wrapper';
import { accountService } from '@/projects/admin/services/account-service';
import { accountParameterService } from '@/projects/admin/services/account-parameter-service';
import { createCustomStore } from '@/core/wrappers/custom-store-wrapper';


const App = (props: any) => {
  const { accountId } = props;

  const [accountParameterStore] = useState(createCustomStore({
    key: ['id'],
    load: accountParameterService.getAccountParameters,
    onLoading(loadOptions) {
      if (accountId) {
        loadOptions.filter = ["AccountId", "=", accountId]
      }
    },
    insert: accountParameterService.createAccountParameter,
    update: accountParameterService.updateAccountParameter,
    remove: accountParameterService.deleteAccountParameter,
  }));

  const [accountStore] = useState(createCustomStore({
    key: 'id',
    load: accountService.lookupAccounts,
    byKey: (key, loadOptions) => {
      if (key) {
        loadOptions.filter = ["id", "=", key];
      }
    },
    onLoading(loadOptions) {
      if (accountId) {
        loadOptions.filter = ["Id", "=", accountId]
      }
    },
  }));

  const [parameterTypeDescriptionStore] = useState(createCustomStore({
    key: 'id',
    load: accountParameterService.lookupAccountParameters,
    byKey: (key, loadOptions) => {
      if (key) {
        loadOptions.filter = ["id", "=", key];
      }
    },
  }));

  const handleRowUpdating = async (e: any) => {
    e.newData = { ...e.oldData, ...e.newData }
  };

  return (
    <DataGridWrapper
      datasource={accountParameterStore}
      permissonCode='Admin.Account.Parameter'
      onRowUpdating={handleRowUpdating}
      pagerVisible={true}
      filterVisible={true}
      headerFilterVisible={true}
      enableCustomToolbarContent={false}
      searchPanelVisible={true}
      columnChooser={false}
      props={{
        id: "account-parameter-list-grid",
        remoteOperations: true,
      }}
      columns={[
        {
          dataField: "id",
          visible: false
        },
        {
          dataField: "accountId",
          caption: t("account_name"),
          lookup: {
            dataSource: accountStore,
            valueExpr: "id",
            displayExpr: "name"
          }
        },
        {
          dataField: "parameterAccountParameterTypeId",
          caption: t("parameter_name"),
          lookup: {
            dataSource: parameterTypeDescriptionStore,
            valueExpr: "id",
            displayExpr: "description"
          }
        },
        {
          dataField: "value",
          caption: t("parameter_value")
        }
      ]}
    />
  );
};
export default App;